<template>
  <solo-card>
    <template slot="title">
      <h3>{{ $t('PAGE_resetpass_title') }}</h3>
      <p>{{ $t('PAGE_resetpass_marketing') }}</p>
    </template>
    <template slot="default">
      <b-form @submit.prevent="reset">
        <b-alert :show="requestState === 'finished'" variant="primary">
          <small>{{ $t('PAGE_resetpass_email_sent') }}</small>
        </b-alert>
        <div class="row px-3">
          <div role="group" class="w-100">
            <b-form-input
              type="email"
              name="email"
              id="id_email"
              aria-describedby="emailHelp"
              :state="resetTried && emailInvalid ? 'invalid' : null"
              :placeholder="$t('emailaddress')"
              v-model="email"
              required
            />
            <b-form-feedback id="input-feedback">
              {{ $t('emailaddress_invalid_message') }}
              <small>(hans.muster@bechterew.ch)</small>
            </b-form-feedback>
          </div>
        </div>

        <b-button
          :disabled="(resetTried && emailInvalid) || requestState === 'loading'"
          type="submit"
          variant="primary"
          class="w-100 mt-3"
        >
          <span v-if="requestState === 'loading'"> <loader /> </span>
          <span v-else>{{ $t('PAGE_resetpass_button') }}</span>
        </b-button>
      </b-form>
      <div class="form-group row px-3">
        <p class="mx-auto">
          <small>
            <router-link class="text-secondary" tag="a" :to="{ name: 'home' }">
              {{ $t('PAGE_resetpass_abort') }}
            </router-link>
          </small>
        </p>
      </div>
    </template>
  </solo-card>
</template>

<script>
import { mapGetters } from 'vuex';

import Loader from '@/components/Loader';
import SoloCard from '@/components/SoloCard';

export default {
  name: 'resetpass',
  components: { Loader, SoloCard },
  computed: {
    ...mapGetters(['requestState']),
    emailInvalid() {
      return !/.*@.*\..*/.test(this.email);
    },
  },
  data() {
    return {
      resetTried: false,
      email: '',
    };
  },
  methods: {
    reset() {
      this.resetTried = true;

      if (!this.emailInvalid)
        this.$store.dispatch('requestResetPassword', { email: this.email });
    },
  },
};
</script>

<style scoped>
.maxW500 {
  max-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Resetpass.vue